export  default {

    setSignedIn(state, value) {
        state.signedIn = value;
    },

    setCurUser(state, value) {
        state.curUser = value;
    },

    /*getMenuItems(state, data) {
        state.menuItems = data;
    },*/

    setWebUserInfo(state, data) {
        state.webUser = data;
    },

    //обновить аватар пользователя
    changeWebUSerLogo(state, logoModel) {
        if (logoModel != null) {
            state.webUser.webUserLogo = logoModel.newLogoId;
        }
    },

    setMenu(state, data) {
        if(data != null)
        {
            state.menuItems = data
        }
    }
}
